import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '🐢️',
    title: 'pages.onboarding.paceQuestion.answer1',
    subtitle: 'pages.onboarding.paceQuestion.answer1Subtitle',
  },
  {
    emoji: '🚶‍♂️',
    title: 'pages.onboarding.paceQuestion.answer2',
    subtitle: 'pages.onboarding.paceQuestion.answer2Subtitle',
  },
  {
    emoji: '🚀',
    title: 'pages.onboarding.paceQuestion.answer3',
    subtitle: 'pages.onboarding.paceQuestion.answer3Subtitle',
  },
  {
    emoji: '🌈',
    title: 'pages.onboarding.paceQuestion.answer4',
    subtitle: 'pages.onboarding.paceQuestion.answer4Subtitle',
  },
]

export default function PaceQuestionPage() {
  return (
    <SingleChoiceQuestionPage
      answers={answers}
      subtitle="pages.onboarding.paceQuestion.subtitle"
      title="pages.onboarding.paceQuestion.title"
    />
  )
}
